import { getProtectedAuthArea } from '@/lib/auth/protectedArea'

type InitialCustomerVerifyParams = {
  pathname: string
  hasCustomerSessionHint: boolean
  hasPersistedUser: boolean
}

export function shouldVerifyCustomerAuthOnMount({
  pathname,
  hasCustomerSessionHint,
  hasPersistedUser,
}: InitialCustomerVerifyParams): boolean {
  if (getProtectedAuthArea(pathname) === 'account') {
    return true
  }

  if (hasCustomerSessionHint) {
    return true
  }

  return hasPersistedUser
}
